import * as preact from 'preact'
import styles from './index.css'
const { h } = preact

const Wall = ({ animate }) => {
  const className = `${styles.wall} ${animate ? styles['wall--animate'] : null}`
  return (
    <picture className={className}>
      <source
        srcset="
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.webp 400w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.webp 800w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1200.webp 1200w"
        type="image/webp"
      />
      <source
        srcset="
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.png 400w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.png 800w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1000.png 1000w"
        type="image/png"
      />
      <img
        alt=""
        className={className}
        srcset="
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-400.png 400w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-800.png 800w,
          https://static.nrk.no/dh/module/stille-spesial/assets/Kloster/wall-1000.png 1000w"
      />
    </picture>
  )
}

export { Wall }



// WEBPACK FOOTER //
// ./src/v1/components/Body/Kloster/wall.tsx